import { BaseModel } from './base.model';

export class UnconformityModel extends BaseModel {

    description: string;
    criticality: number

    // question unc
    checklist_id: number;
    inspection_plan_id: number;

    // for save on api
    unconformity_id: number;

    static validate(unconformity: UnconformityModel): boolean {
        return !!(unconformity.description);
    }

    constructor(unconformity?: UnconformityModel) {
        super();

        this.description = unconformity ? unconformity.description || null : null;
        this.criticality = unconformity ? unconformity.criticality || null : null;

        this.checklist_id = unconformity ? unconformity.checklist_id || null : null;
        this.inspection_plan_id = unconformity ? unconformity.inspection_plan_id || null : null;

        this.unconformity_id = unconformity ? unconformity.unconformity_id || null : null;
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/unconformity.model.ts